import { ref, watch } from "vue";
import { getRefs } from "../utils";
import { onClickOutside } from "@vueuse/core";

interface MultiSelectProps {
  rootEl: HTMLElement;
  onSelectionChange?: (selection: string) => void;
  options: { id: string; label: string }[];
}

export const MultiSelect = (props: MultiSelectProps) => {
  const refs = getRefs<{ button: HTMLButtonElement; panel: HTMLElement }>(props.rootEl);
  const open = ref(false);

  const selected = new Set<string>();

  refs.button.addEventListener("click", (e) => {
    open.value = !open.value;
  });

  onClickOutside(refs.panel, (e) => {
    if (open.value) {
      e.stopPropagation();
      open.value = false;
    }
  });

  for (const option of props.options) {
    const button = document.createElement("button");
    button.classList.add("multiselect--option");
    button.innerText = option.label;

    button.addEventListener("click", () => {
      const isSelected = selected.has(option.id);

      if (isSelected) {
        selected.delete(option.id);
        button.removeAttribute("aria-selected");
      } else {
        selected.add(option.id);
        button.setAttribute("aria-selected", "true");
      }

      if (props.onSelectionChange) {
        props.onSelectionChange(Array.from(selected).join(","));
      }
    });

    refs.panel.append(button);
  }

  watch(
    open,
    (open) => {
      if (open) {
        refs.panel.classList.remove("hidden");
      } else {
        refs.panel.classList.add("hidden");
      }
    },
    { immediate: true }
  );
};
